<template>
    <div class="user-attributes">
        <v-row class="my-2 mx-4">
            <h1 class="text-left ">User Attributes</h1>
        </v-row>
        <v-card class="mx-2 pa-3 " outlined >
        <v-row>
          <v-col cols="12">    
            <v-row class="my-1">
              <v-col cols="12" md="9">
                <h2 class="text-left mx-4">Custom Attributes</h2>
              </v-col>
              <v-col cols="12" md="3">
                <v-btn
                  color="primary white--text"
                  class="text-right"
                  @click="addAttribute();handleTourDialog();"
                  id="add-attribute"
                >
                  Add Attribute
                </v-btn>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headers"
              :items="user_attributes"
              class="elevation-1"
              hide-default-footer
              disable-pagination
            >
              <template v-slot:item.actions="{ item }">
                  <v-icon
                    class="mr-2"
                    @click="editAttribute(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                        @click="attribute = item; deleteDialog=true"
                    >
                        mdi-delete
                    </v-icon>
                
              </template>
              
              <template v-slot:item.is_student="{ item }">
                  <v-icon v-if="item.is_student" color="primary">mdi-check</v-icon>
                  <v-icon v-else color="red">mdi-close</v-icon>
              </template>
              <template v-slot:item.is_faculty="{ item }">
                  <v-icon v-if="item.is_faculty" color="primary">mdi-check</v-icon>
                  <v-icon v-else color="red">mdi-close</v-icon>
              </template>
              <template v-slot:item.is_admin="{ item }">
                  <v-icon v-if="item.is_admin" color="primary">mdi-check</v-icon>
                  <v-icon v-else color="red">mdi-close</v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
      <v-row justify="center">
          <ConfirmationDialog
            title="Add Attribute    "
            successText="Save"
            :disableSuccessButton="!attributeForm"
            @successCallback="saveAttribute"
            failureText="Cancel"
            @failureCallback="dialog=false"
            :visible="dialog"
          >
            <v-form v-model="attributeForm" ref="attributeForm">
                <v-text-field
                    v-model="attribute.label"
                    outlined
                    label="Title"
                    class="rounded-input mx-5"
                    :rules="[rules.required]"
                    hide-details="auto"
                    dense
                >
                </v-text-field>
                <v-row no-gutters>
                    <v-col cols="12" md="6">
                        <v-checkbox
                            v-model="attribute.is_student"
                            label="Assign to Students"
                            hide-details="auto"
                            class="mx-5"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="12" md="6">
                        
                        <v-checkbox
                            v-model="attribute.is_faculty"
                            label="Assign to Staff"
                            hide-details="auto"
                            class="mx-5"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="12" md=6>
                        <v-checkbox
                            v-model="attribute.is_admin"
                            label="Assign to Admin"
                            hide-details="auto"
                            class="mx-5"
                        ></v-checkbox>
                    </v-col>
                    
                </v-row>
                
            </v-form>
          </ConfirmationDialog>
      </v-row>
        <!-- delete item dialog -->
        <v-row justify="center">
            <ConfirmationDialog
                title="Are you sure you want to delete this attribute?"
                description="All the associated data stored for all the users of the assigned type(s) will be deleted. This action cannot be reversed."
                successText="Delete"
                @successCallback="deleteAttribute(attribute)"
                failureText="Cancel"
                @failureCallback="deleteDialog=false;"
                :visible="deleteDialog"
            >
            </ConfirmationDialog>
        </v-row>

      <v-snackbar v-model="snackbar.visible" timeout="5000" :color="snackbar.color" multi-line>
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn dark text v-bind="attrs" @click="snackbar.visible = false">Close</v-btn>
        </template>
      </v-snackbar>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ConfirmationDialog from "@components/widgets/dialogs/ConfirmationDialog";
import api from "@api/index";
import endpoints from "@api/repository";
import Helper from "@utils/misc";
import TourHelper from "@utils/tour_helper";


export default {
    name: 'UserDocumentTypes',
    components:{
        ConfirmationDialog
    },
    data(){
        return{
            user_attributes: [],
            attributeForm: false,
            is_editing: false,
            attribute: {
                label: null,
                is_student: false,
                is_faculty: false,
                is_admin: false,
                institution: false,
            },
            dialog: false,
            deleteDialog: false,
            rules: {
                required: (v) => !!v || "Required",
            },
            headers: [
                {
                    text: 'Label',
                    value: 'label',
                    align: 'start',
                    sortable: false,
                },
                {
                    text: 'Assign to Students',
                    value: 'is_student',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Assign to Staff',
                    value: 'is_faculty',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Assign to Admin',
                    value: 'is_admin',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                }
            ],
            snackbar: {
                visible: false,
                text: "",
                color: "dark",
            },       
        }
    },
    computed: {
      ...mapGetters(["currentUser","currentInstitution","accessToken", "isLoading"]),

        apiEssentials() {
          return {
            accessToken: this.accessToken,
            handleErrorsFunction: this.handleApiErrors,
            setLoading: this.setLoading,
          };
        },
    },
    methods:{
        ...mapActions(['setLoading']),

        handleTour() {
        var steps = [];
        steps.push({id: '1', title:"User Attribute", description: "In this section add a attribute that can be uploaded is assigned."});
        steps.push({id: '2', description: "Add attribute that you want assign by filling neccessary information.", position:'top' ,el: '#add-attribute'});
        // steps.push({id: '3', description: "Select a classroom for further instructions", position:'top' ,el: '#add-row-item'});
        // steps.push({id: '4', description: "Select a classroom for further instructions", position:'top' ,el: '#save-timetable'});
        TourHelper.startTour(this, "user__attribute__types", steps);
    },

    handleTourDialog() {
        var steps = [];
        // steps.push({id: '1', title:"User Document Types", description: "In this section add a document that can be uploaded is assigned."});
        steps.push({id: '1', description: "click on checkbox for assigning the attribute to preffered section.", position:'top'});
        // steps.push({id: '3', description: "Select a classroom for further instructions", position:'top' ,el: '#add-row-item'});
        // steps.push({id: '4', description: "Select a classroom for further instructions", position:'top' ,el: '#save-timetable'});
        TourHelper.startTour(this, "user__attribute__dialog", steps);
    },

        async getAllAttributes(){
            this.user_attributes = await api.call(this.apiEssentials,endpoints.userAttributes)
        },

        addAttribute(){
            this.attribute = {
                label: null,
                is_student: false,
                is_faculty: false,
                is_admin: false,
                institution: null,
            };
            this.dialog = true;
        },

        editAttribute(attribute){
            this.attribute = Helper.clone(attribute);
            this.is_editing = true;
            this.dialog = true;
        },

        async deleteAttribute(attribute){
            var url = endpoints.userAttributes + `${attribute.id}/`;
            let response = await api.call(this.apiEssentials,url,api.Methods.DELETE);
            if(response){
                this.snackbar.text = "Attribute Deleted"
                this.snackbar.visible = true;
                this.deleteDialog = false;
                this.getAllAttributes();
                
            }
        },

        async saveAttribute(){
            var response = null;
            if(this.is_editing){
                var url = endpoints.userAttributes + `${this.attribute.id}/`;
                response = await api.call(this.apiEssentials,url, api.Methods.PUT, this.attribute)
            }
            else{
                this.attribute.institution = this.currentInstitution.id
                response = await api.call(this.apiEssentials,endpoints.userAttributes, api.Methods.POST, this.attribute)
            }
            if(response){
                this.snackbar.text = "Attribute Saved Successfully";
                this.snackbar.visible = "True";
                this.is_editing = false;
                this.dialog=false;
                this.getAllAttributes();
            }
        }
    },
    created(){
        this.getAllAttributes();
        this.handleTour();
    }
}

</script>
